import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import "./ModalEtiqueta.scss"
import { DataInContext } from '../../../context/DataInContext';

function ModalEtiqueta(props) {
    const { 
        USER, 
        idArea, 
        fetchEtiquetas, 
        setLoadingEtiq, 
        setErrorEtiq, 
        setEtiquetas 
    } = useContext(DataInContext)

    const [newEtiqueta, setNewEtiqueta] = useState({
        nombre: "",
    })

    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    useEffect(()=>{

    },[])

    const handleClose = () => {
        setErrors({})
        setNewEtiqueta({
            nombre: ""
        })
        // obj etiqueta
        // id etiqueta
        setModalErr(null)
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewEtiqueta({
          ...newEtiqueta,
          [name]: value,
        })
    }

    const validateForm = (data) => {
        const errors = {}
        if(!data.nombre.trim()) {
            errors.nombre = "Escriba el nombre de la etiqueta."
        }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newEtiqueta);
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            const obj = {
                user: USER,
                idArea,
                nombreEtiqueta: newEtiqueta.nombre
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/etiquetas/addEtiqueta`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                if(data.error !== 0){
                    setModalErr(data.codeError)
                } else {
                    props.onHide()
                    setErrors({})
                    setNewEtiqueta({
                        nombre: ""
                    })
                    setModalErr(null)
                    // actualizar etiquetas
                    fetchEtiquetas()
                    .then(res => {
                        if(res.status !== 0){
                        setLoadingEtiq(false)
                        setErrorEtiq(res.codeError)
                        } else {
                        setLoadingEtiq(false)
                        setEtiquetas(res.objeto)
                        }
                    })
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    return (
        <Modal
            {...props}
            // size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__empleado'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>Agregar etiqueta</h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className='form__etiqueta d-flex flex-column' onSubmit={handleSubmit}>
                    <div className='mb-2'>
                        <label className='mb-1'>Nombre</label>
                        <input
                            onChange={handleChange}
                            type="text" 
                            id="nombre" 
                            name="nombre" 
                            autoFocus
                            className="form-control form-control-sm col-12"
                            value={newEtiqueta.nombre}
                        />
                        {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                    </div>
                    {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                    <button 
                        type='submit' 
                        className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                    >
                        Agregar etiqueta
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalEtiqueta